import { EmpPrefixEnum } from "@gtpl/shared-models/common-models";
import { BaseEntity, Column, Entity, Index, JoinColumn, JoinTable, ManyToMany, ManyToOne, OneToMany, OneToOne, PrimaryColumn, PrimaryGeneratedColumn, RelationId, VersionColumn, UpdateDateColumn, CreateDateColumn } from "typeorm";
import { EmployeeDetails } from "./employee-details.entity";

// import { VendorsPriceList } from "../vendors-price-list/entities/vendor-price-list.entity";

@Entity('employee_education_details')
export class EmployeeEducationDetails {

    @PrimaryGeneratedColumn("increment", { name: 'employee_education_id' })
    employeeEducationId: number;

    @Column("varchar", {
        nullable: true,
        length: 50,
        name: "emp_qualification"
    })
    empQualification: string;

    @Column("varchar", {
        nullable: true,
        length: 50,
        name: "specialization"
    })
    specialization: string;
  @Column("datetime" , {
        nullable : true,
        name: "date_of_passout"
    })
    dateOfPassOut: Date;
    @Column("int", {
        nullable: true,
        name: "percentage"
    })
    percentage: number;

    @Column("boolean", {
        nullable: true,
        default: true,
        name: "is_active"
    })
    isActive: boolean;
    @CreateDateColumn({
        name: "created_at",
        type: "datetime"
    })
    createdAt: Date;

    @Column("varchar", {
        nullable: true,
        name: "created_user"
    })
    createdUser: string | null;


    @UpdateDateColumn({
        name: "updated_at",
        type: 'datetime'
    })
    updatedAt: Date;

    @Column("varchar", {
        nullable: true,
        name: "updated_user"
    })
    updatedUser: string | null;


    @VersionColumn({
        default: 1,
        name: "version_flag"
    })
    versionFlag: number;

   
                    

    @ManyToOne(type => EmployeeDetails, empInfo => empInfo.educationDetails, { nullable: true, })
    @JoinColumn({ name: "employee_id" })
    employeeDetails: EmployeeDetails;


}
